import { Component, input } from '@angular/core';

import {
  ButtonComponent,
  CamOverlayPanelComponent,
  ColorSetDisplayerComponent,
  LayoutFullPanelComponent,
} from '@camelot/ui';
import { CamClickOrDoubleClickDirective, ModalState } from '@camelot/utils';

import { IEvent } from '../../types/event';
import { CamPlanningEditEventContent, CamPlanningEditEventDataTeplate } from '../form/event/event.component';

export const eventCardImports = [
  ButtonComponent,
  CamClickOrDoubleClickDirective,
  CamOverlayPanelComponent,
  CamPlanningEditEventContent,
  ColorSetDisplayerComponent,
  LayoutFullPanelComponent,
];

@Component({
  selector: 'app-calendar-event-card',
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  imports: eventCardImports,
})
export class CamEventCardComponent {
  event = input.required<IEvent>();

  public editModal = new ModalState<CamPlanningEditEventDataTeplate, null>();

  public edit() {
    this.editModal.asked({ event: this.event() });
  }
  public show = (overlay: CamOverlayPanelComponent) => () => {
    overlay.open(true);
  };
  public goTo() {
    console.log('goto');
  }
}
